module.exports = __webpack_public_path__ + "static/media/sunshine.aee3d911.gif";